/** @format */

import { useEffect } from "react";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import FadeLoader from "react-spinners/FadeLoader";
import Footer from "../components/Footer";
import Headers from "../components/Headers";
import { messageClear } from "../store/reducers/homeReducer";
import { useCategories } from "../utils/Categories";

const BlogDetails = () => {
  const navigate = useNavigate();
  const { loader, successMessage, messageError } = useSelector(
    (state) => state.auth,
  );
  const dispatch = useDispatch();

  const { categories, clientLocation } = useCategories();
  //console.log("categories ", categories)
  //if (loading) return <div>Loading...</div>;
  // if (errorMessage) return <div>Error: {errorMessage}</div>;
  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage);
      dispatch(messageClear());

      navigate("/login");
    }
    if (messageError) {
      toast.error(messageError);
      dispatch(messageClear());
    }
  }, [successMessage, messageError, dispatch, navigate]);

  return (
    <div>
      {loader && (
        <div className='w-screen h-screen flex justify-center items-center fixed left-0 top-0 bg-gray-500/70 z-[99999]'>
          <FadeLoader />
        </div>
      )}
      <Headers categories={categories} clientLocation={clientLocation} />
      <div className='h-[1px] bg-black w-full my-2 flex'></div>
      <div
        className='py-5 flex shadow-lg md-lg:flex md-lg:flex-col md-lg:w-[90%] md:w-[90%]  
                                  sm:w-[95%] w-[85%] mx-auto'
      >
        <div className='justify-center items-center w-[70%]'>
          <p className='text-sm font-semibold text-slate-600 p-5'>
            Accueil » Approvisionnement en produits » Vêtements & Accessoires »
            Comment porter un pantalon de yoga à jambes larges pour le bureau
          </p>
          <div className='w-full px-4 py-2 md-lg:w-[100%]'>
            <img
              src='https://img.baba-blog.com/2025/02/sexy-woman-in-office-ready-orange-wide-leg-yoga-pants.jpg?x-oss-process=style%2Ffull'
              alt=''
            />
            <h1 className='text-bold text-2xl p-2'>
              Comment porter un pantalon de yoga large pour le bureau
            </h1>
            <span className='font-thin p-2'>
              Posté par <span className='text-blue-400 '>Kimeyada</span> le
              12/02/2023
            </span>
            <div className='w-full flex justify-between items-center p-2 flex-col'>
              <p className='text-sl text-slate-600 p-2 text-justify font-montserrat'>
                Les pantalons de yoga larges sont bien plus qu'un simple
                incontournable de la garde-robe du yogi ! Ils sont devenus une
                tenue polyvalente, idéale pour une sortie décontractée ou même
                pour un look de bureau.{" "}
              </p>
              <p className='font-montserrat text-slate-600 p-2 text-justify'>
                Pour les personnes qui privilégient le confort mais qui
                souhaitent néanmoins conserver une image professionnelle sur
                leur lieu de travail, apprendre à porter des pantalons de yoga
                au travail peut changer radicalement la donne.{" "}
              </p>
            </div>
          </div>
          <div className='w-full px-4 py-2 md-lg:w-[100%]'>
            <h1 className='text-bold text-2xl p-2'>
              1. Pantalon de yoga évasé et technique du pantalon rentré
            </h1>
            <img
              src='https://img.baba-blog.com/2025/02/corporate-woman-wearing-tucked-in-wide-leg-yoga-pants.jpg?x-oss-process=style%2Ffull'
              alt=''
            />
            <div className='w-full flex justify-between items-center p-2 flex-col'>
              <p className='text-sl text-slate-600 p-2 text-justify font-montserrat'>
                Un chemisier long ou une tunique ajoutera sûrement de la
                couverture et créera une silhouette équilibrée lorsqu'il sera
                associé à pantalon de yoga à jambes largesLe porteur doit
                simplement s'assurer que le chemisier ou la tunique couvre ses
                hanches pour une apparence plus professionnelle.
              </p>
              <p className='font-montserrat text-slate-600 p-2 text-justify'>
                Cependant, pour une allure plus raffinée et professionnelle, il
                est conseillé de rentrer un chemisier dans un pantalon de yoga.
                Cette technique simple mais efficace permet de définir la taille
                et de créer une silhouette flatteuse, idéale pour les occasions
                formelles. Les chemisiers en soie sont la meilleure option, car
                ils apportent une touche de luxe à la tenue.
              </p>
            </div>
          </div>
        </div>
        <div className='w-[30%] px-4 py-2 md-lg:w-[100%]'>
          <input
            type='text'
            placeholder='Search'
            className='px-4 py-2 focus:border-indigo-500 outline-none
                          border border-slate-700 rounded-md text-[#d0d2d6] w-full'
          />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default BlogDetails;
